import React, {Component} from 'react';
import {addSubField} from "../../../../../store/actions/subFields";
import connect from "react-redux/es/connect/connect";
import {FieldGroupContext} from "../../../../../contexts/FieldGroupContext";
import {FieldGroup} from "../FieldGroup";
import ParametersNotice from "../../Parameters/ParametersNotice";
import CustomTableNotice from '../../CustomTableNotice';

class Ordering extends Component {

	render() {

		const { settings, action } = this.props;

		return (
			<FieldGroupContext.Consumer>

				{({ endpointId, endpoint, currentItem, action }) => (

					( ( action === 'displayCustomTable' ||
						action === 'createCustomTable' ||
						action === 'editCustomTable' ||
						action === 'deleteCustomTable' ) && endpoint[action][currentItem].tableSelection[0].fields[0].value === '') ?
						<CustomTableNotice/> :

					<React.Fragment>

						<ParametersNotice parameters={endpoint.parameters}/>

						<FieldGroup label="Order by" fields={settings.endpoints[endpointId][action][0].orderby[0].fields} group="orderby" groupId={0} currentItem={currentItem} action={action}/>
						<FieldGroup label="Order" fields={settings.endpoints[endpointId][action][0].order[0].fields} group="order" groupId={0} currentItem={currentItem} action={action}/>
					</React.Fragment>
				)}

			</FieldGroupContext.Consumer>
		);
	}
}

const mapStateToProps = ( state ) => ( state );

const mapDispatchToProps = dispatch => ({
	addSubField: ( endpointId, field, currentItem, group, parentGroup ) => dispatch( addSubField( endpointId, field, currentItem, group, parentGroup ) ),
});

export default connect( mapStateToProps, mapDispatchToProps )(Ordering);
